import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-screen-xl mx-auto my-8" }
const _hoisted_2 = { class: "py-4 relative" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.Images.get('/img/rubin_logo_icon.png'),
        alt: "Rubin Logo",
        class: "w-12 absolute top-0 left-1/2 -ml-6"
      }, null, 8, _hoisted_3),
      _hoisted_4
    ])
  ]))
}